let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8hizo")).then(() => parcelRequire('2Pj0H'));